import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractFormDialogData, AbstractFormDialog, AbstractDialogResultData } from '@next/core-lib/dialog';

export interface MultipleSelectDialogItem<T> {
  key: string;
  value: T;
  name: string;
}

export interface MultipleSelectDialogValue<T> {
  value: T;
  name: string;
}

export interface MultipleSelectDialogResultItem<T> {
  key: string;
  value: T;
}

export interface MultipleSelectDialogData<T> extends AbstractFormDialogData {
  items: MultipleSelectDialogItem<T>[];
  values: MultipleSelectDialogValue<T>[];
  text?: string;
  emptyText?: string;
}

@Component({
  selector: 'app-multiple-select-dialog',
  templateUrl: './multiple-select-dialog.component.html',
  standalone: false,
})
export class MultipleSelectDialogComponent<T> extends AbstractFormDialog<MultipleSelectDialogResultItem<T>[]> {
  data = inject<MultipleSelectDialogData<T>>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected readonly mdDialogRef =
    inject<MatDialogRef<MultipleSelectDialogComponent<T>, AbstractDialogResultData<MultipleSelectDialogResultItem<T>[]>>>(MatDialogRef);

  formGroup = this.formBuilder.group({
    select: this.formBuilder.array(this.data.items.map(({ value }) => value)),
  });

  select(data: { select: T[] }) {
    super.confirm(
      data.select.map((value, i) => ({
        key: this.data.items[i].key,
        value,
      })),
    );
  }
}
